export const mockTeachers = [
  {
    id: 1,
    name: '山田 花子',
    role: 'キッズ英会話担当',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/2adfd714462c2279825c84acda6318eb.jpeg',
    experience: '英語教育歴12年。児童英語教育の専門家として、子どもたちの成長を見守り続けています。TESOL資格保持。',
    message: '子どもたちの「できた！」という笑顔が何よりの喜びです。一人ひとりの個性を大切にしながら、楽しく英語を学べる環境づくりを心がけています。'
  },
  {
    id: 2,
    name: '佐藤 健一',
    role: 'ビジネス英語担当',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/0cb90a4551759c2faf31331a5e2c46bd.jpeg',
    experience: '外資系企業での勤務経験10年。実践的なビジネス英語指導に定評があります。TOEIC990点満点取得。',
    message: 'ビジネスの現場で本当に使える英語を教えることを大切にしています。皆さんのキャリアアップを全力でサポートいたします。'
  },
  {
    id: 3,
    name: '中村 優子',
    role: '中高生英会話担当',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/0ba0255a6bab9da9264786f6a667e90f.jpeg',
    experience: '英語教育歴8年。中高生の受験対策から実践的な会話力育成まで幅広く指導。英検1級、TOEIC950点取得。',
    message: '思春期の皆さんの気持ちに寄り添いながら、英語の楽しさと実用性を伝えています。受験だけでなく、将来本当に使える英語力を一緒に身につけましょう！'
  },
  {
    id: 4,
    name: '鈴木 太郎',
    role: 'オンラインレッスン担当',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/23b5c65cbe47e9c2b4b82662d6ae9959.jpeg',
    experience: '海外留学経験5年。オンライン教育のスペシャリストとして、遠隔でも効果的な指導を実現しています。',
    message: 'オンラインでも対面と変わらない質の高いレッスンを提供します。テクノロジーを活用して、楽しく効率的に学びましょう。'
  }
];